(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3816],{

/***/ 99418:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-promotions/[uid]",
      function () {
        return __webpack_require__(42993);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ make; }
});

// EXTERNAL MODULE: ./src/bindings/Pino.bs.js
var Pino_bs = __webpack_require__(91574);
// EXTERNAL MODULE: ./src/components/pages/terms/TermsHeader.bs.js
var TermsHeader_bs = __webpack_require__(84270);
// EXTERNAL MODULE: ./node_modules/react-render-html/index.js
var react_render_html = __webpack_require__(68341);
var react_render_html_default = /*#__PURE__*/__webpack_require__.n(react_render_html);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/PrezzeePublicClient.bs.js + 15 modules
var PrezzeePublicClient_bs = __webpack_require__(47861);
;// CONCATENATED MODULE: ./src/components/pages/terms/TermsPromotionsSingle.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









function TermsPromotionsSingle(props) {
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(TermsHeader_bs/* make */.S, {
                title: props.promotionTermTitle
            }),
            jsx_runtime.jsx("div", {
                children: react_render_html_default()(props.promotionTerm),
                className: "prose-lg container mx-auto tracking-wider my-20 px-8"
            })
        ]
    });
}
function getServerSideProps(param) {
    var query = param.query;
    if (Belt_Option.isNone(Js_dict.get(query, "preview"))) {
        param.res.setHeader("Cache-Control", Constants.ssr_page_cache);
    }
    var uid = Belt_Option.getWithDefault(Js_dict.get(query, "uid"), "");
    return Js_promise.$$catch(function(e) {
        Pino.logger.error({
            err: e,
            source: "Articles By Slug API"
        }, "error: Could not retrieve Single Promotion Term");
        return Promise.resolve({
            props: {
                promotionTermTitle: "",
                promotionTerm: ""
            }
        });
    }, Js_promise.then_(function(singleTerm) {
        return Promise.resolve({
            props: {
                promotionTermTitle: singleTerm.title,
                promotionTerm: singleTerm.content
            }
        });
    }, PrezzeePublicClient.getPromotionTermsSingle(uid)));
}
var make = TermsPromotionsSingle;
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/pages/terms-promotions/[uid].js
__webpack_require__(14473);

var __N_SSP = true;



/***/ }),

/***/ 84270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE


function TermsHeader(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("span", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(props.title),
                className: "font-extrabold text-3xl md:text-4xl"
            }),
            className: "container mx-auto "
        }),
        className: "relative py-20 lg:py-24 xl:py-32 bg-prezzee-red text-white px-8"
    });
}
var make = TermsHeader;
 /* Util Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8764,8341,9774,2888,179], function() { return __webpack_exec__(99418); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);